import { createFetcher } from '@composables/createFetcher';
import { featureFlags } from '@lib/feature.flags';
import { useAccountStore } from '@/stores/account.store';

type TelemetryPayload = {
  metric: string;
  resource: string;
};

export const useTelemetryFetcher = () => {
  const accountStore = useAccountStore();
  const fetcher = createFetcher<TelemetryPayload>({
    endpoint: '/telemetry',
    method: 'POST',
    requiresAuth: true,
    requiresArtistId: true,
    useQueueApi: true,
    validatePayload: (payload) => {
      if (!payload.metric) {
        fetcher.error.value = 'No metric found';
        return false;
      }
      if (!payload.resource) {
        fetcher.error.value = 'No resource found';
        return false;
      }
      return true;
    },
  });

  const execute = async (newPayload: TelemetryPayload) => {
    if (!featureFlags.telemetry) {
      console.info(
        'telemetry is disabled in development. payload:',
        newPayload,
        'authToken:',
        accountStore.authToken,
      );
      return;
    }

    await fetcher.execute(newPayload, accountStore.authToken);
  };

  return {
    execute,
    data: fetcher.data,
    error: fetcher.error,
    isFetching: fetcher.isFetching,
  };
};
